import { UserEntity } from "@/entities/UserEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";
import {getUser} from "@/services/api/auth.js";

const entity = new UserEntity();
export async function getUsers({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getUserById({id}) {
    const response = await apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });

    const me = await getUser();
    const corpData = Object.values(response.data.corps).find(corp => corp.id === me.corpId);

    const permissions = Object.entries(corpData?.workgroups ?? {}).map(([name, id]) => ({
        title: name,
        value: id
    }));

    return {
        data: {
            ...response.data,
            permissions
        }
    };
}

export async function saveUser(data) {
    const isUpdate = !!data.id;
    let url = isUpdate
        ? entity.getUrl(entity.endpoints.get, { id: data.id })
        : entity.endpoints.create;

    const response = await apiRequest({
        client: window.API_AUTH,
        method: isUpdate ? "put" : "post",
        url,
        body: data,
    });

    return response;
}

export async function deleteUser({id}) {
    const url = entity.getUrl(entity.endpoints.delete, { id });
    return apiRequest({
        client: window.API_AUTH,
        method: "delete",
        url,
    });
}

export async function sendPasswordAuthorizationKey({ login }) {
    return apiRequest({
        client: window.API_AUTH,
        method: "post",
        url: "/user/sendPasswordAuthorizationKey",
        body: { login },
    });
}

export async function reset2FA({id}) {
    const url = entity.getUrl(entity.endpoints.reset2FA, { id });
    return apiRequest({
        client: window.API_AUTH,
        method: "POST",
        url,
    });
}

export async function change2FA({data}) {
    const changeTo = data.two_factor_required ? 'disable': 'enable';
    return await apiRequest({
        client: window.API_AUTH,
        method: "PUT",
        url: `/user/${data.id}/${changeTo}2FA`
    });
}
